import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./bullets.css";
import ProductCard from "../ProductCard";

// Fetch function
const fetchLatestProducts = async () => {
  const { data } = await axios.get(
    "https://gouridistribution.com/new_arrival?size=15&page=1",
  );
  if (!data.success) throw new Error("Failed to fetch products");
  return data.result.products;
};

const LatestProducts = () => {
  const {
    data: products,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["latestProducts"],
    queryFn: fetchLatestProducts,
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  if (isLoading) {
    return (
      <div className="w-full py-24 flex flex-col justify-center items-center gap-4">
        <div className="w-12 h-12 border-4 border-[#998147] border-t-transparent rounded-full animate-spin"></div>
        <p className="text-[#15363A] font-medium animate-pulse">
          Loading Latest Products...
        </p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="w-full pb-20 text-center">
        <p className="text-red-500 font-bold text-lg">
          Oops! Something went wrong.
        </p>
        <p className="text-gray-500">{error.message}</p>
      </div>
    );
  }

  return (
    <section className=" pb-16 px-5 md:px-0 mb-32 bg-white">
      <div className=" mx-auto">
        {/* Header */}
        <div className="md:px-24 mb-12 flex items-center justify-between">
          <div>
            <h2 className="text-2xl md:text-5xl font-bold text-[#15363A]">
              Latest <span className="text-[#998147]">Products</span>
            </h2>
            <div className="w-24 md:h-1.5 h-1 bg-[#998147] mt-4"></div>
          </div>
          <Link
            to="/products"
            className="text-[#998147] font-semibold underline underline-offset-4 hover:text-[#6e6d5d]"
          >
            View All
          </Link>
        </div>

        {/* Swiper Slider */}
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={10}
          slidesPerView={1}
          loop
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            340: { slidesPerView: 1.5 },
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
            1280: { slidesPerView: 6.25 },
          }}
          className="products pb-16 h-[35rem] "
        >
          {products?.map((product) => (
            <SwiperSlide key={product.id}>
              <ProductCard product={product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default LatestProducts;
